{
  "name": "client-app",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start-ssl": "ng serve --ssl --host 0.0.0.0 --disable-host-check",
    "start": "ng serve --host 0.0.0.0 --disable-host-check",
    "build": "ng build",
    "build-prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.4",
    "@angular/common": "^19.1.4",
    "@angular/compiler": "^19.1.4",
    "@angular/core": "^19.1.4",
    "@angular/forms": "^19.1.4",
    "@angular/material": "^19.1.5",
    "@angular/material-moment-adapter": "^19.1.5",
    "@angular/platform-browser": "^19.1.4",
    "@angular/platform-browser-dynamic": "^19.1.4",
    "@angular/router": "^19.1.4",
    "@cantoo/pdf-lib": "^2.4.0",
    "@ngx-translate/core": "16.0.4",
    "angularx-qrcode": "^19.0.0",
    "bootstrap": "^5.3.3",
    "fast-xml-parser": "^5.2.3",
    "leaflet": "^1.9.4",
    "moment": "2.30.1",
    "ng2-pdf-viewer": "^10.4.0",
    "pizzip": "^3.1.8",
    "raygun4js": "^3.1.3",
    "rxjs": "~7.5.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.5",
    "@angular/cli": "~19.1.5",
    "@angular/compiler-cli": "^19.1.4",
    "@types/jasmine": "~4.0.0",
    "angular-eslint": "19.3.0",
    "eslint": "^9.23.0",
    "jasmine-core": "~4.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "^5.7.3",
    "typescript-eslint": "8.27.0"
  }
}
